/**
 * Empty tab panel for vendor detail sections whose data sources are not live.
 */
import { Alert } from "@flint/ui";

export interface VendorDetailEmptyTabProps {
  title: string;
  description: string;
}

export function VendorDetailEmptyTab({ title, description }: VendorDetailEmptyTabProps) {
  return (
    <section className="rounded-md border border-line bg-paper p-5 shadow-sm">
      <Alert intent="info" title={title} description={description} />
    </section>
  );
}
